export const ArrowForwardIcon = () => (<svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6615 18.521L23 10.0003L12.6615 1.47949" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M21.5645 10H0.600228" stroke="white" strokeLinecap="round" strokeLinejoin="round"/>
</svg>);

